var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconCheckBoxWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 12,
  viewBox: "0 0 13 12"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M11.374 0L3.773 9.036 1.472 6.848 0 8.248 3.945 12 13 1.236z"
})));
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDEzIDEyIj48cGF0aCBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS4zNzQgMEwzLjc3MyA5LjAzNiAxLjQ3MiA2Ljg0OCAwIDguMjQ4IDMuOTQ1IDEyIDEzIDEuMjM2eiIvPjwvc3ZnPg0K";
export { SvgIconCheckBoxWhite as ReactComponent };